import { Shield } from "lucide-react";

const LegalFooter = () => {
  return (
    <footer className="border-t border-border bg-background">
      <div className="container mx-auto px-4 py-8">
        <div className="mb-6 grid gap-6 md:grid-cols-3">
          {/* Brand */}
          <div>
            <div className="mb-2 flex items-center gap-2">
              <Shield className="h-4 w-4 text-primary" />
              <span className="font-mono text-sm font-bold uppercase tracking-wider text-foreground">
                Global Conflict Monitor
              </span>
            </div>
            <p className="text-xs text-muted-foreground">
              Real-time OSINT aggregation from verified open sources worldwide.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="mb-2 font-mono text-xs font-medium uppercase tracking-wider text-muted-foreground">
              Quick Links
            </h4>
            <div className="flex flex-col gap-1">
              <button onClick={() => document.getElementById("threats-near-me")?.scrollIntoView({ behavior: "smooth" })} className="text-left text-xs text-muted-foreground hover:text-foreground">Threats Near Me</button>
              <button onClick={() => document.querySelector('[data-tab-bar]')?.scrollIntoView({ behavior: "smooth" })} className="text-left text-xs text-muted-foreground hover:text-foreground">Live Map & Tools</button>
              <button onClick={() => document.getElementById("faq")?.scrollIntoView({ behavior: "smooth" })} className="text-left text-xs text-muted-foreground hover:text-foreground">FAQ</button>
              <button onClick={() => document.getElementById("donate")?.scrollIntoView({ behavior: "smooth" })} className="text-left text-xs text-muted-foreground hover:text-foreground">❤️ Donate</button>
            </div>
          </div>

          {/* Support */}
          <div>
            <h4 className="mb-2 font-mono text-xs font-medium uppercase tracking-wider text-muted-foreground">
              Support
            </h4>
            <div className="flex flex-col gap-1">
              <a href="mailto:support@globalconflictsmonitor.com" className="text-xs text-muted-foreground hover:text-foreground">Contact Us</a>
              <a href="/privacy" className="text-xs text-muted-foreground hover:text-foreground">Privacy Policy</a>
              <a href="/terms" className="text-xs text-muted-foreground hover:text-foreground">Terms of Service</a>
              <p className="mt-2 text-xs text-muted-foreground">
                📧 <a href="mailto:support@globalconflictsmonitor.com" className="text-primary hover:underline">support@globalconflictsmonitor.com</a>
              </p>
            </div>
          </div>
        </div>

        {/* Legal disclaimer */}
        <div className="rounded-lg border border-warning/20 bg-warning/5 p-4">
          <p className="text-center text-[11px] leading-relaxed text-muted-foreground">
            <strong className="text-warning">OSINT Disclaimer:</strong> This platform aggregates
            publicly available OSINT (Open Source Intelligence) and international news sources. It
            does not replace official government or civil protection communications. In case of
            emergency, follow instructions from local authorities.
          </p>
        </div>

        <div className="mt-4 text-center text-[10px] text-muted-foreground">
          © {new Date().getFullYear()} Global Conflict Monitor. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default LegalFooter;
